module.exports = __webpack_public_path__ + "static/media/shield.73a8bb3a.svg";